export default __webpack_public_path__ + "static/media/trolley-marker-adhoc-plus.6d91ad3f.svg";